import { useMutation } from '@tanstack/react-query';

import { fetchSendVoiceMessage } from '../../fetch/fetchSendVoiceMessage';

export default function useSendVoiceMessage() {
  return useMutation({
    mutationFn: ({ audioBlob, session_id }) => fetchSendVoiceMessage(audioBlob, session_id),
  });
}

